import React, { createContext, useContext } from 'react'

export type FeatureFlags = Record<string, any>

export const FeatureFlagsContext = createContext<FeatureFlags | null>(null)

export function FeatureFlagsProvider({ flags, children }: { flags: FeatureFlags; children: React.ReactNode }) {
  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>
}

export function useFeatureFlagsContext(): FeatureFlags | null {
  return useContext(FeatureFlagsContext)
}
